<!-- order-list 1 -->

<template>
  <div style="background-color: #e5e5e5; height: 100vh">
    <van-tabs v-model="active" :before-change="tabs_beforeChange" sticky>
      <van-tab v-for="tab of tabs" :key="tab" :title="tab">
        <!-- 订单列表为空 -->
        <van-empty v-if="!orderList || orderList.length < 1" description=""></van-empty>

        <van-list v-model="loading" :finished="finished" finished-text="没有更多了 C" @load="list_onLoad">
          <div v-for="order in orderList" :key="order.orderId" style="background-color: #eee; margin: 8px 0">
            <van-cell :border="false" style="background-color: #fafafa">
              <div class="order-status">
                <div class="order-status-time">{{ order.orderId }}</div>

                <van-tag v-if="order.statusPay === 0 && order.statusOrder === 0" round color="#fff"
                  text-color="#f00">等待付款</van-tag>

                <van-tag v-else-if="order.statusPay === 1" round color="#fff" text-color="#f00">已支付</van-tag>
                <van-tag v-else-if="order.statusPay === 4" round color="#fff" text-color="#f00">已退款</van-tag>
                <van-tag v-else-if="order.statusExpress === 2" round color="#fff" text-color="#919191">已发货</van-tag>
                <van-tag v-else-if="order.statusPay === 1 && (order.statusOrder === 1 || order.statusOrder === 2)" round
                  color="#fff" text-color="#f00">退款中</van-tag>
                <van-tag v-else-if="order.statusOrder === 3" round type="primary" color="#fff"
                  text-color="#919191">已取消</van-tag>
                <van-tag
                  v-else-if="order.orderType === 'movie' && order.statusPay === 1 && (order.statusOrder === 0 || order.statusOrder === 5)"
                  round type="primary" color="#fff" text-color="#919191">出票中</van-tag>

                <!-- 锁定座位 -->
                <van-tag v-else-if="order.statusOrder === 'N'" round color="red">锁定座位</van-tag>
                <van-tag v-else-if="order.statusOrder === 'C'" round>已关闭</van-tag>

                <!-- 未知状态 -->
                <van-tag v-else color="#fff" text-color="#919191">
                  {{ order.statusPay | payStatusFilter }}
                  {{ order.statusOrder | orderStatusFilter }}
                </van-tag>
              </div>
            </van-cell>

            <!-- 每个商品 可能是电影 -->
            <div v-for="goods of order.goods" :key="goods.goodsName">
              <van-card :desc="goods.desc ? goods.desc : '  '" :num="goods.goodsQuantity" :thumb="goods.goodsHeadImage"
                style="background-color: #fff">
                <template #title>
                  <span style="font-weight: 800" @click="order2detail(order)">{{ goods.goodsName }}</span>
                </template>

                <template #price>
                  <div
                    v-if="(order.orderType === 'movie' || order.orderType === 'Qipiao_qqqppp') && order.cardQuantity > 0">
                  </div>
                  <div v-else>
                    <div v-if="order.orderType !== 'movie' && order.cardQuantity > 0"></div>
                    <div v-else>
                      <img class="price-icon"
                        src="https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20241230/t81502o1cbv1u2pptwopkson.png" />
                      <span style="font-size: 14px">{{ goods.goodsPrice | money }}</span>
                    </div>
                  </div>
                </template>

                <template #tags>
                  <van-tag v-for="t of goods.spec" :key="t" plain style="margin-right: 4px; font-size: 12px"
                    type="danger"> {{ t }} </van-tag>
                </template>
              </van-card>
            </div>

            <!-- 海威点餐 和 京东锦礼 -->
            <van-cell v-if="
              order.goodsType === 'HW_H5' ||
              order.goodsType === 'JDJL' ||
              order.goodsType === 'YHCS' ||
              order.goodsType === 'WDG' ||
              order.goodsType === 'shoutu_h5'
            " :border="false" icon="filter-o" style="font-size: 12px" :title="order.body">
            </van-cell>

            <!-- 不是电影 -->
            <van-cell v-if="!(order.orderType !== 'movie' && order.cardQuantity > 0)" :border="false"
              style="background-color: #fff" title="合计">
              <template>
                <div v-if="order.orderType === 'movie' && order.cardQuantity > 0">
                  {{ order.cardQuantity }} 次
                </div>
                <div v-else>
                  <img class="price-icon"
                    src="https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20241230/t81502o1cbv1u2pptwopkson.png" />
                  <span style="font-size: 14px"> {{ order.fee | money }} </span>
                </div>
              </template>
            </van-cell>

            <van-cell v-if="order.statusPay === 0 && order.statusOrder === 0">
              <div style="display: flex; align-items: center; margin-right: 10px; font-size: 12px; flex: 1;">
                <van-icon name="clock-o" />
                支付剩余时间：
                <van-count-down :time="order.timeDown" format="mm 分 ss 秒" @finish="count_down_finish(order)" />
              </div>
            </van-cell>

            <!-- 商城商品开始 -->
            <van-cell v-if="order.splitDate" icon="info-o" is-link label="因仓库发货原因，订单已自动拆分" style="font-size: 12px"
              title="订单已拆分" value="查看详情" @click="showSubOrder(order.orderId)">
            </van-cell>

            <van-cell v-if="order.statusExpress > 0" :is-link="order.statusExpress === 2" icon="logistics"
              style="font-size: 12px" @click="showExpressInfo(order.expressInfo)">
              <template #title>
                <span v-if="order.statusExpress === 1">待发货</span>
                <span v-else-if="order.statusExpress === 2">已发货</span>
              </template>
              <span v-if="order.statusExpress === 2">查看详情</span>
            </van-cell>
            <!-- 商城商品结束 -->

            <!-- 电影信息 2 -->
            <van-cell v-if="
              order.orderType === 'movie' || order.orderType === 'Qipiao_qqqppp'
            " :border="false" icon="video-o" style="font-size: 12px" title="电影信息">
              <template #label>
                <div v-if="order.goods && order.goods.length > 0" style="line-height: 20px">
                  影厅：{{ order.goods[0].roomname }}<br />
                  座次：{{ order.goods[0].seats }}<br />
                  播放时间：{{ order.goods[0].playtime }}
                </div>
              </template>
            </van-cell>

            <van-cell v-if="order.goods && order.goods.length > 0 && order.goods[0].ticketcode" :border="false"
              :label="order.goods[0].ticketcode" icon="coupon-o" style="font-size: 12px" title="取票信息"></van-cell>

            <van-cell v-if="order.goods && order.goods.length > 0 && order.goods[0].qrcode" :border="false"
              icon="coupon-o" @click="showQrcode(order.goods[0].qrcode)" style="font-size: 12px" title="查看二维码">
            </van-cell>
            <!-- 电影-结束 -->

            <van-cell style="text-align: right; background-color: #fafafa">
              <div style="text-align: right; background-color: #fafafa">
                <van-button v-if="order.orderType != 'movie' && order.orderType != 'Qipiao_qqqppp'" plain round
                  size="small" style="margin-left: 8px" @click="order2detail(order)">订单详情</van-button>

                <!-- 京东锦礼 永辉超市 隐藏此按钮 -->
                <van-button
                  v-if="order.statusPay === 0 && order.statusOrder === 0 && order.timeDown > 0 && 'YHCS' != order.orderType && 'JDJL' != order.orderType"
                  plain round size="small" style="margin-left: 8px" type="primary" @click="order2detail(order)"
                  class="budo-180">立即支付</van-button>

                <!-- 京东锦礼隐藏此按钮 进详情在京东的页面上操作取消 -->
                <!-- 永辉的 在此处操作取消 因为我方已经扣卡券未微信补差的订单 永辉侧认为未支付 没有取消回调 -->
                <van-button v-if="
                  order.statusPay === 0 &&
                  order.statusOrder === 0 &&
                  'JDJL' != order.orderType
                " plain round size="small" style="margin-left: 8px" type="danger"
                  @click="cancelOrder(order.orderId)">取消订单</van-button>

                <van-button v-if="order.statusOrder === 3" plain round size="small" style="margin-left: 8px"
                  type="danger" @click="deleteOrderById(order.orderId)">删除订单</van-button>

                <!-- 券码 -->
                <van-button v-if="order.codes && order.codes.length > 0" plain round size="small"
                  style="margin-left: 8px" type="danger" @click="showCardInfo(order.orderId)">查看券码</van-button>

                <!-- 电影锁定座位 -->
                <van-button v-else-if="order.statusOrder === 'N'" plain round size="small" type="danger"
                  @click="xuankua_order_cancel(order)">关闭订单</van-button>
              </div>
            </van-cell>
          </div>
        </van-list>
      </van-tab>
    </van-tabs>

    <van-dialog v-model="showExpressInfoFlag" :show-cancel-button="false" confirm-button-text="关闭" message-align="left"
      style="padding: 4px" title="快递信息">
      <express-info v-if="showExpressInfoFlag" :exp-info="expInfo"></express-info>
    </van-dialog>

    <van-popup v-model="showSubOrderFlag" :style="{ height: '50%' }" position="bottom">
      <sub-order-list :order-id="parentOrderId" @showExpInfo="showExpressInfo"></sub-order-list>
    </van-popup>

    <!-- 展示券码的弹窗 -->
    <OrderCodeDialog ref="OrderCodeDialog" />

    <van-dialog v-model="qrcodeVisible" @opened="getQrcodeImage" style="padding: 24px; text-align: center">
      <div class="qrcode" ref="qrCodeImage" v-if="qrcodeVisible"></div>
    </van-dialog>
  </div>
</template>

<script>
import {
  wx_cancel_order,
  deleteOrder,
  mall_orders_get_order_goods_list,
} from "@/api/goods-api";
import SubOrderList from "@/views/user-center/order-list/goods/sub-order-list";
import ExpressInfo from "@/views/user-center/order-list/goods/express-info";
import OrderCodeDialog from "@/components/common/OrderCodeDialog";
import { Toast, Dialog } from "vant";
import QRCode from "qrcodejs2";
import request from "@/util/axios";

export default {
  name: "order-list",

  components: { SubOrderList, ExpressInfo, OrderCodeDialog },

  data() {
    return {
      orderList: [],
      loading: false,
      finished: false,
      pi: 1,
      pageTotal: 1,
      showExpressInfoFlag: false,
      showSubOrderFlag: false,
      expressInfo: {},
      expressDetail: {},
      parentOrderId: "",
      expInfo: {},

      visibleCardInfo: false,
      tickets: [],

      active: 1,
      tabs: ["全部", "待支付", "已支付", "已完成", "已取消"],
      qrcodeVisible: false,
      qrcode: "",
    };
  },

  created() {
    this.orderType = this.$route.query.orderType;
    this.cateCode = this.$route.query.cateCode;
    this.active = parseInt(this.$route.query.tabIndex || 0);
    this.tabs_beforeChange(this.active);

    // 查询已锁定的电影座位 在RC系统中还未产生订单 但专资审核人员会来这里取消锁座
    this.loadOrderMovieLockSeat();
  },

  methods: {
    xuankua_order_cancel(order) {
      Dialog.confirm({
        message: `确定关闭此订单?`,
      }).then(() => {
        request.put("/mall/admin/FlOrdersMovie/xuankua_order_cancel", {
          tradeno: order.goods[0].tradeno,
        }).then((res) => {
          console.log("#229 xuankua_order_cancel", res);

          if (res?.data?.success) {
            $budo_toast("关闭成功");
            order.statusOrder = "C"; // 已关闭
            return;
          }

          $budo_toast("关闭失败 " + JSON.stringify(res));
        });
      });
    },

    loadOrderMovieLockSeat() {
      // 当前用户锁座订单
      request.post("/mall/admin/FlOrdersMovie/user_order_movie_lock_seat", {}).then((res) => {
        var unshiftArray = [];

        if (res?.data?.length > 0) {
          for (var i = 0; i < res?.data?.length; i++) {
            // 数据格式 @see movie_order
            unshiftArray.push({
              fee: res?.data[i].showPrice,
              statusOrder: res?.data[i].orderstatus,
              orderType: "movie",
              cardQuantity: res?.data[i].quantity,
              createTime: res?.data[i].createTime,
              goods: [
                {
                  goodsName: res?.data[i].moviename,
                  goodsHeadImage: res?.data[i].movielogo,
                  goodsQuantity: res?.data[i].quantity,
                  spec: [res?.data[i].edition],
                  desc: res?.data[i].cinemaname,
                  ...res?.data[i],
                },
              ],
            });
          }
        }

        // 如果有的话 添加到界面的最顶部
        this.orderList.unshift(...unshiftArray);
      });
    },

    showQrcode(qrcode) {
      this.qrcodeVisible = true;
      this.qrcode = qrcode;
    },

    getQrcodeImage() {
      new QRCode(this.$refs.qrCodeImage, {
        text: this.qrcode,
        width: 180,
        height: 180,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
    },

    tabs_beforeChange(index) {
      this.active = index;
      if (index === 1) {
        this.statusOrder = 0;
        this.statusPay = 0;
      } else if (index === 2) {
        this.statusPay = 1;
        this.statusOrder = "";
      } else if (index === 3) {
        this.statusOrder = 4;
        this.statusPay = 1;
      } else if (index === 4) {
        this.statusOrder = 3;
        this.statusPay = "";
      } else {
        this.statusOrder = "";
        this.statusPay = "";
      }

      this.pi = 1;
      this.pageTotal = 1;
      this.orderList = [];
      this.finished = false;
      this.loading = true;
      this.list_onLoad();
    },

    deleteOrderById(orderId) {
      deleteOrder(orderId).then((res) => {
        if (res.code === 0) {
          this.orderList = this.orderList.filter((o) => o.orderId !== orderId);
        } else {
          Toast("订单删除失败：不允许删除");
        }
      });
    },

    showCardInfo(orderId) {
      budo_log.info("#272 order-list, showCardInfo, orderId=", orderId);

      this.$refs.OrderCodeDialog.showCardInfo(orderId);
    },

    showExpressInfo(info) {
      budo_log.info("#581 showExpressInfo", info);

      if (info) {
        this.showExpressInfoFlag = true;
        this.expInfo = info;
        return;
      }

      $budo_toast("没有物流信息");
    },

    showSubOrder(orderId) {
      this.parentOrderId = orderId;
      this.showSubOrderFlag = true;
    },

    movie_order(item) {
      let time = item.createTime.split("-").join("/");
      item.timeDown =
        new Date(time).setMinutes(new Date(time).getMinutes() + 10) -
        new Date();

      item.movie = item.goods[0];
      item.goods.map((g) => {
        g.goodsName = g.moviename;
        g.goodsHeadImage = g.movielogo;
        g.goodsQuantity = g.quantity;
        g.goodsPrice = (g.payamount / g.quantity) * 100;
        g.spec = [g.edition];
        g.desc = g.cinemaname;
        return g;
      });

      return item;
    },

    list_onLoad() {
      budo_log.debug("#344 list_onLoad, query=", this.$route.query, "pi=", this.pi);

      if (this.pi <= this.pageTotal) {
        budo_log.debug("#400 mall_orders_get_order_goods_list, this.pi=", this.pi);

        mall_orders_get_order_goods_list(
          this.statusOrder,
          this.statusPay,
          this.pi,
          10,
          "",
          "",
          "GENERAL_GOODS"
        ).then((res) => {
          this.pageTotal = res.data.pages;
          this.orderList.push(
            ...res.data.records.filter((e) => {
              // budo_log.info("#406", e.orderId, this.orderList) // 发现有重复的请求 这里排一下重
              return !this.orderList.find((o) => o.orderId == e.orderId); // 发现有重复的请求 这里排一下重
            }).map((item) => {
              var createTime = item?.createTime || "";
              let time = createTime.split("-").join("/");
              item.timeDown =
                new Date(time).setMinutes(new Date(time).getMinutes() + 10) -
                new Date();
              return item;
            }).map((item) => {
              if ("movie" === item.orderType ||
                "Qipiao_qqqppp" === item.orderType) {
                return this.movie_order(item); // 电影类型的 处理下数据结构
              }
              return item;
            })
          );

          budo_log.debug("#413 orderList", this.orderList);

          this.pi++;

          // 加载状态结束
          this.loading = false;
        });
      } else {
        this.finished = true;
      }
    },

    // 倒计时结束 重新刷新订单
    count_down_finish(order) {
      budo_log.info("#449 count_down_finish", order);

      this.list_onLoad();
    },

    go_HW_H5_order_detail(orderId) {
      Toast("去订单 ...");

      var formData = new FormData();
      formData.append("orderId", orderId);

      request.post("/mall/hw-h5-order-detail-url", formData).then((res) => {
        budo_log.info("#463 hw-h5-order-detail-url", res);
        if (res && res.data) {
          location.href = res.data;
          return;
        }

        Dialog.alert({ message: res.msg || "跳转到HW订单失败 #423" });
      });
    },

    go_JDJL_order_detail(orderId) {
      Toast("去订单 ...");

      var formData = new FormData();
      formData.append("orderId", orderId);

      request.post("/mall/rc-jd-jl-order-url", formData).then((res) => {
        budo_log.info("#434 rc-jd-jl-order-url", res);
        if (res && res.data) {
          location.href = res.data;
          return;
        }

        Dialog.alert({ message: res.msg || "跳转到JDJL订单失败 #440" });
      });
    },

    go_YHCS_order_detail(orderId) {
      Toast("去订单 ...");

      var formData = new FormData();
      formData.append("orderId", orderId);

      request.post("/mall/rc-yhcs-order-url", formData).then((res) => {
        budo_log.info("#452 rc-yhcs-order-url", res);
        if (res && res.data) {
          location.href = res.data;
          return;
        }

        Dialog.alert({ message: res.msg || "跳转到YHCS订单失败 #458" });
      });
    },

    go_WDG_order_detail(orderId) {
      Toast("去订单 ...");

      var formData = new FormData();
      formData.append("orderId", orderId);

      request.post("/mall/rc-wdg-order-url", formData).then((res) => {
        budo_log.info("#476 rc-wdg-order-url", res);
        if (res && res.data) {
          location.href = res.data;
          return;
        }

        Dialog.alert({ message: res.msg || "跳转到WDG订单失败 #482" });
      });
    },

    order2detail(order) {
      budo_log.info("#449 order2detail", order);

      if ("HW_H5" == order.goodsType) {
        this.go_HW_H5_order_detail(order.orderId);
        return;
      }

      if ("JDJL" == order.goodsType) {
        this.go_JDJL_order_detail(order.orderId);
        return;
      }

      if ("YHCS" == order.goodsType) {
        this.go_YHCS_order_detail(order.orderId);
        return;
      }

      if ("WDG" == order.goodsType) {
        this.go_WDG_order_detail(order.orderId);
        return;
      }

      Toast("跳转到订单 ..");

      this.$router.push({
        path: "user-center-order-submit-detail",
        query: { orderId: order.orderId },
      });
    },

    cancelOrder(orderId) {
      wx_cancel_order(orderId).then((res) => {
        if (res.code === 0 && res.data === true) {
          Toast({ message: "取消订单成功", duration: 1000 });
          this.$emit("update");
          this.$router.push(this.orderListUrl);
        } else {
          Toast({ message: "取消订单失败：" + res.msg, duration: 1000 });
        }

        this.$router.go(0);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.qrcode {
  display: inline-block;
  width: 192px;
  height: 192px;
  background-color: #fff;
  padding: 6px;
  box-sizing: border-box;
  margin-bottom: 24px;
}

.order-status {
  text-align: right;
  font-size: 12px;
  color: #f00;
  overflow: hidden;

  .order-status-time {
    float: left;
    color: #919191;
  }

  span {
    margin-left: 2px;
  }
}

.price-icon {
  width: 18px;
  height: 18px;
}

::v-deep .van-overlay {
  background-color: rgba(0, 0, 0, 0.1);
}
</style>
